// subpages-sitemap-wrap content-change-wrap
/**
 * Dragscroll for .subpages-sitemap
 */
function initDragScroll() {
	if (window.innerWidth < breakpointMobile) {
		var $subpagesSitemap = $('.content-change-wrap > .subpages-sitemap');
		if ($subpagesSitemap.hasClass('dragscroll')) {
			return;
		}
		$subpagesSitemap.addClass('dragscroll');
		$subpagesSitemap.addClass('horizontal');
		$subpagesSitemap.addClass('nochilddrag');
		resetDragScroll();
	} else {
		var $subpagesSitemap = $('.content-change > .subpages-sitemap');
		$subpagesSitemap.removeClass('dragscroll');
		$subpagesSitemap.removeClass('horizontal');
		$subpagesSitemap.removeClass('nochilddrag');
		resetDragScroll();
	}
}

function resetDragScroll() {
	if (typeof dragscroll !== 'undefined') {
		setTimeout(function () {
			dragscroll.reset()
		}, 20);
	}
}

// .content-change
/**
 * hide page border after .content-change
 */
function hidePageBorderAfterContentChange() {
	if (window.innerWidth < breakpointMobile) {
		$('.content-change').each(function () {
			var $pageBorder = $(this).closest('.wrapper').next();
			if ($pageBorder.hasClass('is-hidden')) {
				return;
			}
			$pageBorder.addClass('is-hidden');
		})
	} else {
		$('.content-change').each(function () {
			var $pageBorder = $(this).closest('.wrapper').next();
			$pageBorder.removeClass('is-hidden');
		})
	}
}

/**
 * Preselection of .content-change based on Url-Params
 */

const pageSectionSlug = 'sectionid';
const pageIdSlug = 'page-id';
const pageSectionDataAttribute = 'id';
var localWindowStorage = window.localStorage;

function initContentChange() {
	var $contentChange = $('.content-change');

	if ($contentChange.length <= 0) {
		removeStoredSectionParam();
		removeStoredPageId();
		return;
	}

	// on this page is a .content-change element
	if (isNewPage()) {
		removeStoredSectionParam();
		handlePreselection();
	} else {
		handlePreselection();
	}

	contentChangeHook();
}

function isNewPage() {
	let storedPageId = localWindowStorage.getItem(pageIdSlug);
	let currentPageId = $('body').attr(pageIdSlug);

	// page got not stored yet - user did not visit it before reload
	if (!storedPageId) {
		storePageId(currentPageId);
		return true;
	}

	// page is the same as before reload, so it's not new
	if (storedPageId === currentPageId) {
		return false;
	}

	// first visit of page
	removeStoredPageId();
	storePageId(currentPageId);
	return true;

}

function handlePreselection() {
	let storedPram = localWindowStorage.getItem(pageSectionSlug);
	let currentParam = $.urlParam(pageSectionSlug);

	// there is a url param for page-section //
	if (currentParam) {

		// check if there is a stored param
		if (storedPram) {
			// same param like before reload
			if (storedPram === currentParam) {
				setPreselectedContentSectionActive(currentParam);
			} else {
				// another param like before
				storeSectionParam(currentParam);
				setPreselectedContentSectionActive(currentParam);
				updateUrl();
			}
		} else {
			// new param
			storeSectionParam(currentParam);
			setPreselectedContentSectionActive(currentParam);
			updateUrl();
		}

	} else {
		// there is no url param for page-section //

		// check if there is a stored param and set that one as active content-change
		if (storedPram) {
			setPreselectedContentSectionActive(storedPram);
			updateUrl();
		} else {
			// set firs tab active
			setInitialStateOfContentChange();
		}

	}


}

$.urlParam = function (name) {
	var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
	if (results == null) {
		return null;
	}
	return decodeURI(results[1]) || 0;
};

function setPreselectedContentSectionActive(param) {
	var $preselectedSection = $('.content-change[' + pageSectionDataAttribute + '="' + param + '"]');
	if ($preselectedSection.length > 0) {
		setContentChangeActive($preselectedSection, false);
	}
}

function setInitialStateOfContentChange() {
	if ($('.content-change').length > 0) {
		var $activeContentChange = $('.content-change').first();
		var id = $activeContentChange.attr(pageSectionDataAttribute);
		if (id) {
			storeSectionParam(id);
			updateUrl();
		}
		setContentChangeActive($activeContentChange, false);
	}
}

function storePageId(pageId) {
	if (!pageId) {
		pageId = $('body').attr(pageIdSlug);
	}
	localWindowStorage.setItem(pageIdSlug, pageId);
}

function removeStoredPageId() {
	localWindowStorage.removeItem(pageIdSlug);
}

function storeSectionParam(id) {
	localWindowStorage.setItem(pageSectionSlug, id);
}

function removeStoredSectionParam() {
	localWindowStorage.removeItem(pageSectionSlug);
}

function updateUrl() {
	var newURL = updateURLParameter(window.location.href, pageSectionSlug, localWindowStorage.getItem(pageSectionSlug));
	window.history.replaceState('', '', newURL);
}

function updateURLParameter(url, param, paramVal) {
	var TheAnchor = null;
	var newAdditionalURL = "";
	var tempArray = url.split("?");
	var baseURL = tempArray[0];
	var additionalURL = tempArray[1];
	var temp = "";

	if (additionalURL) {
		var tmpAnchor = additionalURL.split("#");
		var TheParams = tmpAnchor[0];
		TheAnchor = tmpAnchor[1];
		if (TheAnchor)
			additionalURL = TheParams;

		tempArray = additionalURL.split("&");

		for (var i = 0; i < tempArray.length; i++) {
			if (tempArray[i].split('=')[0] != param) {
				newAdditionalURL += temp + tempArray[i];
				temp = "&";
			}
		}
	} else {
		var tmpAnchor = baseURL.split("#");
		var TheParams = tmpAnchor[0];
		TheAnchor = tmpAnchor[1];

		if (TheParams)
			baseURL = TheParams;
	}

	if (TheAnchor)
		paramVal += "#" + TheAnchor;

	var rows_txt = temp + "" + param + "=" + paramVal;
	return baseURL + "?" + newAdditionalURL + rows_txt;
}

function contentChangeHook() {
	// tab bzw. content-change
	$('.content-change').on('click', function () {
		var id = $(this).attr(pageSectionDataAttribute);
		if (id) {
			storeSectionParam(id);
			updateUrl();
		}
		setContentChangeActive($(this), true);
	});
}

function setContentChangeActive($element, isOnClick) {

	// remove active state
	$('.content-change').removeClass('active');

	// set active state
	var dataId = $element.attr('data-page');
	dataId = '.' + dataId;
	$element.addClass('active');
	$(dataId).removeClass('hide').siblings().addClass('hide');

	// scroll to element with calculated space
	var elementHeight = $element.outerHeight();
	var spacerHeight = $element.closest('.wrapper').siblings('.page-border').first().outerHeight(true);
	if (!spacerHeight || spacerHeight < 0) {
		spacerHeight = 75;
	}

	var scrollTop = (($element.first().offset().top) - (elementHeight + spacerHeight));

	if (window.scrollY >= scrollTop) {
		return;
	}

	function scrollToSection() {
		if (!isOnClick) {
			return;
		}
		$('html, body').animate({
			scrollTop: scrollTop
		}, 600);
	}

	if (window.innerWidth > breakpointMobile) {
		scrollToSection();

	} else {
		centerTabLink($element, '.content-change-wrap > .subpages-sitemap', function () {
			scrollToSection();
		});
	}
}

function centerTabLink(link, linksWrapperSelector, compvareFunction) {
	var $link = link instanceof jQuery ? link : $(link);
	var tabLinkWidth = $link.outerWidth(),
		windowWidth = $(window).width(),
		currentScrollLeft = $(linksWrapperSelector).scrollLeft();
	var targetOffset = windowWidth / 2 - tabLinkWidth / 2;
	var tabOffsetLeft = $link.offset().left + currentScrollLeft;
	var scrollLeftOffset = tabOffsetLeft - targetOffset;
	$(linksWrapperSelector).animate({
		'scrollLeft': scrollLeftOffset
	}, 400, function () {
		// Animation compvare.
		if (compvareFunction) {
			compvareFunction();
		}
	});

}
